export type CoverColor = 'jade' | 'wood' | 'cinnabar' | 'water' | 'gold' | 'silver';

export type Tomo = {
  label: string;
  title: string;
  subtitle: string;
  promise: string;
  features: string[];
  closing: string;
  color: CoverColor;
  cover: string;
  coverAlt: string;
};

export const tomos: Tomo[] = [
  {
    label: 'TOMO I',
    title: 'Diagnóstico del Dinero',
    subtitle: 'Detectá los bloqueos de tu negocio',
    promise:
      'Aprendé a mirar tu espacio con otros ojos y descubrí qué zonas pueden estar generando sensación de estancamiento, desorden o fricción.',
    color: 'jade',
    cover: 'https://cdn.magicpatterns.com/uploads/1jTSLhsdnAAE5G67bmmtAq/TOMO1.jpg',
    coverAlt: 'Portada del Tomo I: Diagnóstico del Dinero — detectá los bloqueos de tu negocio',
    features: [
      'Analizá fachada, entrada y puerta principal',
      'Detectá obstáculos en la circulación',
      'Revisá iluminación y ventilación',
      'Identificá desorden visible e invisible',
      'Analizá escritorio y posición de trabajo',
      'Revisá recepción y zona de cobro',
      'Detectá problemas con espejos, plantas y rincones',
      'Conocé los 5 Elementos',
      'Aprendé a utilizar el Mapa Bagua',
      'Aplicá el Test de los 21 Bloqueos™',
    ],
    closing: 'Antes de mover algo, aprendé a detectar qué necesita realmente tu espacio.',
  },
  {
    label: 'TOMO II',
    title: 'Activadores de Prosperidad',
    subtitle: 'Corregí y activá cada zona de tu negocio',
    promise: 'Una vez que sabés dónde está el problema, necesitás saber qué hacer.',
    color: 'cinnabar',
    cover: 'https://cdn.magicpatterns.com/uploads/7PHFQDwawgixDBsVJN12XP/TOMO2.jpg',
    coverAlt: 'Portada del Tomo II: Activadores de Prosperidad — corregí, equilibrá, transformá',
    features: [
      'Corregí entradas bloqueadas',
      'Mejorá recorridos y circulación',
      'Activá zonas oscuras o descuidadas',
      'Reorganizá escritorio y posición de trabajo',
      'Mejorá recepción y zona de cobro',
      'Utilizá plantas con criterio',
      'Trabajá correctamente con espejos',
      'Incorporá los 5 Elementos',
      'Equilibrá colores y materiales',
      'Activá el sector de prosperidad',
      'Aplicá un plan de corrección de 7 días',
    ],
    closing: 'RETIRAR · REPARAR · MOVER · ORDENAR · ILUMINAR · EQUILIBRAR',
  },
  {
    label: 'TOMO III',
    title: 'Apertura de Caminos',
    subtitle: 'Limpieza, renovación y activación del espacio',
    promise: 'Aprendé a mantener tu negocio renovado y preparado para acompañar cada nueva etapa.',
    color: 'gold',
    cover: 'https://cdn.magicpatterns.com/uploads/8d5pcxQru2F1bjC1qYdBKo/TOMO3.png',
    coverAlt: 'Portada del Tomo III: Apertura de Caminos — limpieza, renovación y activación del espacio',
    features: [
      'Rutina de apertura del negocio',
      'Renovación del aire',
      'Uso consciente del sonido',
      'Aromas y ambiente',
      'Limpieza consciente',
      'Cierre energético y funcional del día',
      'Apertura de nuevas etapas',
      'Renovación mensual',
      'Uso simbólico de agua, luz y plantas',
      'Rutinas para comercios y consultorios',
      'Calendario de mantenimiento',
    ],
    closing: 'Detectaste. Corregiste. Ahora aprendé a mantener el espacio en movimiento.',
  },
];

export type Bonus = {
  number: string;
  title: string;
  tagline: string;
  description: string;
  chips?: string[];
  lines?: string[];
  closing?: string;
  color: CoverColor;
  cover: string;
  coverAlt: string;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Mapa Bagua para Negocios™',
    tagline: 'Guía visual',
    description:
      'Ubicá las 9 áreas del Bagua sobre el plano de tu negocio, oficina o consultorio y aprendé a reconocer dónde se encuentra cada sector.',
    chips: [
      'Prosperidad',
      'Reconocimiento',
      'Relaciones',
      'Familia',
      'Centro',
      'Creatividad',
      'Conocimiento',
      'Carrera',
      'Personas útiles',
    ],
    color: 'jade',
    cover: 'https://cdn.magicpatterns.com/uploads/ohFtVNvFooo1C7YX1ufgQU/bonus1.png',
    coverAlt: 'Portada del Bonus 1: Guía Visual del Bagua para negocios',
  },
  {
    number: '02',
    title: 'Checklist de los 21 Bloqueos del Dinero™',
    tagline: 'Diagnóstico express',
    description:
      'Una herramienta práctica para recorrer tu negocio y detectar rápidamente qué puntos necesitan atención.',
    lines: ['Marcá.', 'Sumá.', 'Identificá prioridades.'],
    closing: 'En pocos minutos vas a saber por dónde empezar.',
    color: 'cinnabar',
    cover: 'https://cdn.magicpatterns.com/uploads/61hJQFKB5ZqeLY31hoHbbX/bonus2.png',
    coverAlt: 'Portada del Bonus 2: Checklist del negocio para detectar bloqueos',
  },
  {
    number: '03',
    title: 'Guía de Colores Feng Shui™',
    tagline: 'Color · Elementos · Armonía',
    description:
      'Una guía visual para combinar colores, materiales y los 5 Elementos según la sensación que quieras transmitir.',
    chips: ['Madera', 'Fuego', 'Tierra', 'Metal', 'Agua'],
    closing: 'Incluye paletas listas para negocios, consultorios, espacios profesionales y centros de bienestar.',
    color: 'wood',
    cover: 'https://cdn.magicpatterns.com/uploads/hTczzRB4QhGktK4ZJCzBnP/BONUS3.jpg',
    coverAlt: 'Portada del Bonus 3: Guía de Colores Feng Shui — color, elementos y armonía',
  },
  {
    number: '04',
    title: 'Las 30 Curas Rápidas™',
    tagline: 'Detecté esto → hago esto',
    description: '30 problemas frecuentes del espacio acompañados de una acción concreta.',
    lines: [
      'Entrada bloqueada → qué hacer.',
      'Escritorio saturado → qué hacer.',
      'Zona oscura → qué hacer.',
      'Planta deteriorada → qué hacer.',
      'Caja desordenada → qué hacer.',
    ],
    closing: 'Abrí la guía. Encontrá el problema. Aplicá la cura.',
    color: 'water',
    cover: 'https://cdn.magicpatterns.com/uploads/6NLgRVkWYcvDAzxujK3xLV/bonus4.png',
    coverAlt: 'Portada del Bonus 4: recetas y curas rápidas de Feng Shui',
  },
  {
    number: '05',
    title: 'Feng Shui para Consultorios™',
    tagline: 'Recibí · Contené · Acompañá',
    description: 'Una guía especial para terapeutas y profesionales que atienden personas.',
    chips: [
      'Recepción',
      'Sala de espera',
      'Escritorio',
      'Camilla',
      'Posición del paciente',
      'Privacidad',
      'Luz',
      'Plantas',
      'Aromas',
      'Circulación',
    ],
    closing: 'Porque la experiencia de tu paciente empieza antes de la consulta.',
    color: 'silver',
    cover: 'https://cdn.magicpatterns.com/uploads/mmwme3aChkHNc4Ca6deL2Q/bonus5.png',
    coverAlt: 'Portada del Bonus 5: Feng Shui para Consultorios',
  },
  {
    number: '06',
    title: 'Calendario de Activación del Negocio™',
    tagline: 'Mantené · Renová · Observá',
    description: 'Convertí todo el método en una rutina fácil de sostener:',
    lines: ['3 minutos diarios', '15 minutos semanales', '30–60 minutos mensuales'],
    closing: 'Incluye checklists, trackers, revisiones trimestrales y planificación anual.',
    color: 'gold',
    cover: 'https://cdn.magicpatterns.com/uploads/e1PRvAVFV7cfMvTh9gB7Jk/bonus6.png',
    coverAlt: 'Portada del Bonus 6: Calendario de Activación del Negocio',
  },
];

export const painPoints: { quote: string; result: string }[] = [
  { quote: 'Siento mi negocio estancado', result: 'Pero no sabés qué cambiar.' },
  { quote: 'No sé dónde está el problema', result: 'Movés objetos y muebles sin ningún criterio.' },
  {
    quote: 'Mi negocio está lindo, pero algo no se siente bien',
    result: 'Hay zonas oscuras, saturadas o mal aprovechadas que ya dejaste de notar.',
  },
  {
    quote: 'Compré objetos Feng Shui y no sé dónde ponerlos',
    result: 'Terminás acumulando todavía más cosas.',
  },
  {
    quote: 'Mi consultorio no transmite lo que quiero',
    result: 'Tus pacientes perciben el espacio antes de que empiece la consulta.',
  },
  {
    quote: 'Quiero renovar mi negocio',
    result: 'Pero pensás que necesitás gastar dinero cambiándolo todo.',
  },
];

export const transformationList: string[] = [
  'qué está bloqueando la entrada,',
  'qué rincón necesita atención,',
  'qué objeto está sobrando,',
  'qué zona necesita luz,',
  'qué mueble convendría mover,',
  'qué área necesita recuperar equilibrio.',
];

export const costs: [string, string][] = [
  ['Sin diagnóstico', 'Cambiás cosas sin saber dónde está el problema'],
  ['Sin mapa del espacio', 'Hay sectores que nunca observás'],
  ['Sin sistema de corrección', 'Movés muebles y objetos al azar'],
  ['Sin criterio de color', 'Elegís solamente por gusto'],
  ['Sin mantenimiento', 'El desorden vuelve'],
  ['Sin mirada del cliente', 'Dejás de notar lo que alguien nuevo percibe'],
];

export const faqs: { q: string; a: string }[] = [
  {
    q: '¿Sirve si no sé nada de Feng Shui?',
    a: 'Especialmente si empezás desde cero. El sistema está organizado paso a paso: primero diagnosticás, después corregís y finalmente activás. No necesitás formación previa.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Una vez confirmado tu pago, recibís automáticamente el acceso al material digital en el email que registraste durante la compra.',
  },
  {
    q: '¿Necesito imprimirlo todo?',
    a: 'No. Podés utilizar los materiales desde tu celular, tablet o computadora. Si preferís trabajar sobre papel, también podés imprimir las páginas que necesites.',
  },
  {
    q: '¿Sirve para un consultorio?',
    a: 'Sí. El sistema puede adaptarse a negocios, oficinas, locales y consultorios. Además, incluimos un bonus específico: Feng Shui para Consultorios™.',
  },
  {
    q: '¿Tengo que comprar objetos Feng Shui?',
    a: 'No. De hecho, uno de los principios centrales del sistema es analizar primero si podés retirar, reparar, mover, ordenar o iluminar antes de agregar nuevos objetos.',
  },
  {
    q: '¿Necesito remodelar mi negocio?',
    a: 'No. Muchas de las correcciones propuestas pueden realizarse modificando distribución, orden, iluminación y mantenimiento.',
  },
  {
    q: '¿Tiene garantía real?',
    a: 'Sí. Tu compra cuenta con 7 días de garantía.',
  },
  {
    q: '¿El Feng Shui garantiza que voy a conseguir más clientes?',
    a: 'No. El sistema no garantiza ventas, clientes ni ingresos. Está pensado para ayudarte a observar, organizar y armonizar el espacio donde desarrollás tu actividad.',
  },
];

export type Testimonial = {
  id: string;
  initials: string;
  name: string;
  context: string;
  text: string;
};

export const firstTestimonial: Testimonial = {
  id: 't0',
  initials: 'ML',
  name: 'Marisa L.',
  context: 'CABA — Local de indumentaria',
  text: 'Mi local estaba lindo pero sentía que algo no funcionaba y no sabía qué. Con el Test de los 21 Bloqueos entendí que la entrada estaba tapada con un exhibidor y que la zona de cobro era el rincón más oscuro. Moví tres cosas, cambié dos luces y saqué lo que sobraba. Hoy entro a trabajar y el espacio se siente ordenado y liviano.',
};

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    initials: 'GP',
    name: 'Gabriela P.',
    context: 'Córdoba — Consultorio de kinesiología',
    text: 'El bonus de consultorios me ordenó la cabeza. Revisé recepción, sala de espera y la posición de la camilla siguiendo la guía. Mis pacientes ya no esperan de espaldas a la puerta y el ambiente se siente mucho más cuidado.',
  },
  {
    id: 't2',
    initials: 'SR',
    name: 'Sofía R.',
    context: 'Rosario — Estudio de diseño',
    text: 'Lo que más uso son las 30 Curas Rápidas. Detecto el problema, busco la página y aplico. No compré ni un objeto nuevo: retiré, ordené e iluminé, tal como propone el sistema.',
  },
  {
    id: 't3',
    initials: 'AM',
    name: 'Andrea M.',
    context: 'Mendoza — Centro de bienestar',
    text: 'Aprender a usar el Mapa Bagua sobre mi propio plano me cambió la mirada. Ahora sé qué sector estoy descuidando y el calendario de activación me ayuda a mantenerlo con quince minutos por semana.',
  },
];

export const buyers: { name: string; location: string }[] = [
  { name: 'Marisa L.', location: 'CABA' },
  { name: 'Gabriela P.', location: 'Córdoba' },
  { name: 'Sofía R.', location: 'Rosario' },
  { name: 'Andrea M.', location: 'Mendoza' },
  { name: 'Paula G.', location: 'La Plata' },
];
